import React, { useCallback } from 'react';
import { ModalType, useModalContext } from '@/context/ModalContext';
import { InvalidCredentialsErrorIcon } from '@/icons/errors';
import BaseModal from '@/components/Modal/BaseModal/BaseModal';
import {
  ModalActions,
  ModalCancelButton,
  ModalContent,
  ModalContentText,
  ModalHeader,
  ModalIcon,
  ModalTitle,
} from '@/components/Modal/Elements';
import CloseButton from '@/components/Modal/Elements/Close/CloseButton';
import { useTranslation } from '@/hooks/useTranslation';

interface Props {}

const TwoAuthLoginErrorModal: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { close } = useModalContext();
  const onClose = useCallback(() => {
    close(ModalType.TWO_AUTH_LOGIN);
  }, []);

  return (
    <BaseModal onClose={onClose}>
      <ModalHeader>
        <CloseButton onClick={onClose} />
      </ModalHeader>
      <ModalIcon>
        <InvalidCredentialsErrorIcon />
      </ModalIcon>
      <ModalContent>
        <ModalTitle>{t('modal.error.login_failed.title')}</ModalTitle>
        <ModalContentText>{t('modal.error.login_failed_2_auth.sub_title')}</ModalContentText>
      </ModalContent>
      <ModalActions>
        <ModalCancelButton onClick={onClose} text={t('button.ok')} />
      </ModalActions>
    </BaseModal>
  );
};

export default TwoAuthLoginErrorModal;
